export default [
  {
    value: 'PAID',
    text: 'Оплачено'
  },
  {
    value: 'RESERVED',
    text: 'Зарезервировано'
  },
  {
    value: 'RESERVATION_EXPIRED',
    text: 'Резервация просрочена'
  },
  {
    value: 'RESERVATION_CANCELLED',
    text: 'Резервация отменена'
  }
]
